import PlanActivity from "shared/lib/interfaces/PlanActivity";
import apiAxios from "../../apiAxios";

export default async function getPlanActivities(): Promise<{
  planActivities: PlanActivity[];
}> {
  const response = await apiAxios.get("/plan");
  return response.data;
}
